import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { AuthService } from 'src/app/services/auth.service';
import { EmailListService } from 'src/app/services/emaillist.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-maillistlist',
  templateUrl: './maillistlist.component.html',
  styleUrls: ['./maillistlist.component.scss'],
})
export class MaillistlistComponent implements OnInit {
  company: any;
  companyid: any;
  mailing_lists: any[];
  maillistLocal: any;
  loading: boolean = false;
  token: any;

  constructor(
    private storage: Storage,
    private emaillistService: EmailListService,
    private authService: AuthService
  ) { }

  async ngOnInit() {
    this.token = await this.authService.getDecodedUserToken();
    this.companyid = this.token.company;

    this.maillistLocal = await this.storage.get('MAILINGLIST');
    if (this.maillistLocal) {
      this.mailing_lists = this.maillistLocal;
    } else {
      this.emaillistService.getEmailListFromCompanySettings(this.companyid).subscribe(x => {
        this.mailing_lists = x;
        this.storage.set(environment.storage.maillinglist, x);
        console.log('EmailList1: ', this.mailing_lists);
      });
    }
  }

  edit(mail) {
    console.log("MAIL: ", mail)
    this.emaillistService.maillistDataSubject.next(mail);//new Subjekt Ermitter
  }

  delete(mail, i) {
    console.log(mail, i)
  }
}
